import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import useFetchCustomers from "../hooks/useFetchCustomers";
import useFetchTransactionDetails from "../hooks/useFetchTransactionDetails";
import MainTabsComponent from '../components/MainTabsComponent';
import './../styles/dashboard.css';

const Dashboard = () => {
  const [activeTab, setActiveTab] = useState("inbound-tab");
 
  const [senderName, setSenderName] = useState(null); 

  const { senderNames, fetchCustomerData, error } = useFetchCustomers(
    activeTab === "inbound-tab" ? "Inbound" : "Outbound", // messageFlowType
    activeTab === "outbound-tab" ? senderName : null // Include senderName only for outbound
  );
  const { transactionsLoading, transactionDetails, fetchTransactions, transactionsError } = useFetchTransactionDetails();
  const navigate = useNavigate();

  const [selectedCustomer, setSelectedCustomer] = useState({
    customerName: "",
    transactionType: "",
    customerReferenceIdentifier: "",
  });

  return (
    <div className="dashboard">
      {error && <div className="error-log">{error}</div>}
      <MainTabsComponent
        selectedCustomer={selectedCustomer}
        setSelectedCustomer={setSelectedCustomer}
        transactionDetails={transactionDetails}
        transactionsLoading={transactionsLoading}
        fetchTransactions={fetchTransactions}
        fetchCustomerData={fetchCustomerData}
        navigate={navigate}
        transactionsError={transactionsError}
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        senderName={senderName} // Pass senderName to the MainTabsComponent
        setSenderName={setSenderName} // Add a function to update senderName in the component
        senderNames={senderNames}
      />
    </div>
  );
};

export default Dashboard;
